import PropTypes from "prop-types";

import { alignItems, strCode } from "../../consts";
import { t } from "../../services";
import { withSection } from "../../hoc";

import { FlexContainers, Modal, Paragraph2, SmallButton, WrapperContainer } from "../../components";
import { Title } from "./styled";

const AppVersionModal = ({ active, setActive, onRefresh }) => {
  return (
    <Modal id="app-version-modal" isRightSideModal active={active} closable={false}>
      <WrapperContainer Container={FlexContainers.FlexColumnStart} gap={24} maxWidth={506}>
        <WrapperContainer
          Container={FlexContainers.FlexColumnStart}
          alignItems={alignItems.start}
          gap={4}
          width={"100%"}>
          <Title>{t(strCode.APP_VERSION_MODAL_TITLE)}</Title>
          <Paragraph2>{t(strCode.APP_VERSION_MODAL_MESSAGE)} </Paragraph2>
        </WrapperContainer>
        <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={16} width={"100%"}>
          <SmallButton secondary secondaryBold onClick={() => setActive(false)}>
            {t(strCode.REMIND_LATER_BTN)}
          </SmallButton>
          <SmallButton onClick={onRefresh}>{t(strCode.REFRESH_NOW_BTN)}</SmallButton>
        </WrapperContainer>
      </WrapperContainer>
    </Modal>
  );
};

AppVersionModal.propTypes = {
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired
};

export default withSection(AppVersionModal);
